// extracted by mini-css-extract-plugin
module.exports = {"capacityInput":"reservedCapacity_capacityInput__3iVzx","periodCol":"reservedCapacity_periodCol__2w9D9","typeCol":"reservedCapacity_typeCol__38dPV"};